import { useEffect } from 'react';

const SitemapXml = () => {
  useEffect(() => {
    // Set the content type to application/xml
    document.querySelector('meta[name="robots"]')?.setAttribute('content', 'noindex, nofollow');
  }, []);

  const sitemapContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <!-- Main Pages -->
  <url>
    <loc>https://addictionrehabcall.com/</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/search</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/treatment-types</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/insurance</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/resources</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/get-help</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
  </url>
  
  <!-- State Pages (High Priority for Local SEO) -->
  <url>
    <loc>https://addictionrehabcall.com/states</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/california</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/texas</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/florida</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/new-york</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/pennsylvania</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/illinois</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/ohio</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/georgia</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/north-carolina</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/states/michigan</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.8</priority>
  </url>
  
  <!-- Facility Signup -->
  <url>
    <loc>https://addictionrehabcall.com/facility-signup</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.6</priority>
  </url>
  
  <!-- Legal Pages -->
  <url>
    <loc>https://addictionrehabcall.com/about</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.5</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/contact</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.5</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/terms</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>yearly</changefreq>
    <priority>0.3</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/privacy</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>yearly</changefreq>
    <priority>0.3</priority>
  </url>
  <url>
    <loc>https://addictionrehabcall.com/sitemap</loc>
    <lastmod>2025-09-19</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.4</priority>
  </url>
</urlset>`;

  return (
    <pre style={{ 
      fontFamily: 'monospace', 
      whiteSpace: 'pre-wrap', 
      margin: 0,
      padding: 0,
      fontSize: '11px'
    }}>
      {sitemapContent}
    </pre>
  );
};

export default SitemapXml;